<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Draggable Survey List</div>
                <!--<button type="submit" v-on:click.prevent="addPoliciesAndForms" class="btn btn-primary waves-effect pull-right">Add</button>-->
            </div>
            <!--page content-->
            <div class="admin-page-content">

                <form id="benefitForm">
                    <div class="">

                        <draggable v-model="surveyList" v-on:change="changePosition()" class="drag-view">
                            <template v-for="(text, index) in surveyList">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-20">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <h2 class="text-muted display-4 text-danger"><strong><small class="text-danger">{{text.title}}</small></strong></h2>
                                            </div>
                                            <!--Image Section-->
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <img :src="text.image_path" class="img-thumbnail" />
                                                </div>
                                                <div class="form-group">
                                                    <p v-html="text.description"></p>
                                                </div>
                                            </div>
                                            <!--End Image Section-->

                                            <!--Button Section-->
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <div class="form-group mt-15">
                                                    <template v-for="(btn, index) in text.button_array">
                                                        <a :href="btn.button_url" target="_blank" class="mt-1 btn btn-primary">{{btn.button_title}}</a><br/>
                                                    </template>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-sm-12 col-xs-12">
                                                <button class="btn btn-danger pull-right"  v-on:click.prevent="deletePoliciesFormsSection(text.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                            </div>
                                            <!--End Button Section-->
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </draggable>
                    </div>
                </form>

            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import BackendFooter from '@/components/backend/partials/Footer';
    import draggable from 'vuedraggable';
    import Vue from "vue";
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'List_Media',
        mixins: [SessioMixin],
        components: {
            draggable,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                surveyList: [],
                redirectionLink: '',
                // imagePosition: [],
            }
        },
        computed: {

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.showLoader();
            self.MenuClose();
            self.getSurveyData();
        },

        methods: {
            addPoliciesAndForms() {
                self.$router.push('/backend/addservey');
            },
            deletePoliciesFormsSection: function (id) {
                var usedArr = [];
                if (id) {
                    usedArr.push(id);
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                var fields = {
                    deleteArr: usedArr,
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post("deletepoliciesandforms", fields, config)
                                .then(function (response) {
                                    self.getSurveyData();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the record(s).', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your record(s) still intact', 'info')
                    }
                });
            },
            getSurveyData() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                self.showLoader();
                HTTP.post("getsurveydata", '', config)
                        .then(function (response) {
                            self.surveyList = response.data.content;
                            /*self.redirectionLink = self.surveyList[0].redirection_link.replace(/^(?:https?:\/\/)?/i, "").split('/')[0];*/
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            changePosition() {
                var fields = {
                    surveyList: self.surveyList,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changepositionsurvey", fields, config)
                        .then(function (response) {
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/surveys/BlockListViewSurveys.vue